var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: _vm.cssVars },
    [
      _c("div", { staticClass: "d-block d-sm-none" }, [
        _c(
          "div",
          {
            staticClass: "header scrollmenu hidden-md-up",
            class: _vm.style.classApply
          },
          [
            _vm.isDesignTime()
              ? _c("span", [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary",
                      on: { click: _vm.headerSetting }
                    },
                    [_c("i", { staticClass: "fa fa-cog" })]
                  )
                ])
              : _vm._e(),
            _vm.propsHeader.LogoUrl
              ? _c("span", [
                  _c("a", { attrs: { href: _vm.webPartUrlFirst() } }, [
                    _c("img", {
                      staticStyle: { height: "100%" },
                      attrs: {
                        src: _vm.toDownloadLink(_vm.propsHeader.LogoUrl)
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._l(this.WebParts, function(webPart, index) {
              return _c("span", { key: "p" + index }, [
                webPart.Title
                  ? _c("span", [
                      _c(
                        "a",
                        {
                          staticClass: "scrollMenuLink",
                          attrs: { href: _vm.webPartUrl(webPart) }
                        },
                        [_vm._v(_vm._s(webPart.Title))]
                      ),
                      _vm.isDesignTime()
                        ? _c("span", [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-primary",
                                staticStyle: { padding: "1px", margin: "1px" },
                                on: {
                                  click: function($event) {
                                    return _vm.moveLeft(webPart)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-arrow-left" })]
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-primary",
                                staticStyle: { padding: "1px", margin: "1px" },
                                on: {
                                  click: function($event) {
                                    return _vm.moveRight(webPart)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-arrow-right" })]
                            )
                          ])
                        : _vm._e(),
                      _c("span", { staticClass: "scrollmenuDiv" }, [
                        _vm._v("|")
                      ])
                    ])
                  : _vm._e()
              ])
            }),
            _vm._l(_vm.propsHeader.MenuLinks, function(item, index) {
              return _c("span", { key: index }, [
                _c(
                  "a",
                  {
                    staticClass: "scrollMenuLink",
                    attrs: { href: item.LinkUrl, target: item.LinkTarget }
                  },
                  [_vm._v(_vm._s(item.LinkText))]
                ),
                _c("span", { staticClass: "scrollmenuDiv" }, [_vm._v("|")])
              ])
            }),
            _vm._l(_vm.getAdvPages(), function(item, index) {
              return _c("span", { key: index }, [
                _c(
                  "a",
                  {
                    staticClass: "scrollMenuLink",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        return _vm.gotoPage(item.SystemId)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.Name))]
                ),
                _c("span", { staticClass: "scrollmenuDiv" }, [_vm._v("|")])
              ])
            })
          ],
          2
        )
      ]),
      _c("div", { staticClass: "d-none d-sm-block " }, [
        _c(
          "div",
          {
            staticClass:
              "header scrollmenu d-flex justify-content-center hidden-md-down",
            class: _vm.style.classApply
          },
          [
            _c("div", { staticClass: "headerAlignControl" }, [
              _c("span", { staticClass: "headerAlignLogo" }, [
                _vm.isDesignTime()
                  ? _c("span", [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-primary",
                          on: { click: _vm.headerSetting }
                        },
                        [_c("i", { staticClass: "fa fa-cog" })]
                      )
                    ])
                  : _vm._e(),
                _vm.propsHeader.LogoUrl
                  ? _c("span", [
                      _c("a", { attrs: { href: _vm.webPartUrlFirst() } }, [
                        _c("img", {
                          staticStyle: { height: "100%" },
                          attrs: {
                            src: _vm.toDownloadLink(_vm.propsHeader.LogoUrl)
                          }
                        })
                      ])
                    ])
                  : _vm._e()
              ]),
              _c(
                "span",
                { staticClass: "headerAlignMenu" },
                [
                  _vm._l(this.WebParts, function(webPart, index) {
                    return _c("span", { key: "p" + index }, [
                      webPart.Title
                        ? _c("span", [
                            _c(
                              "a",
                              {
                                staticClass: "scrollMenuLink",
                                attrs: { href: _vm.webPartUrl(webPart) }
                              },
                              [_vm._v(_vm._s(webPart.Title))]
                            ),
                            _vm.isDesignTime()
                              ? _c("span", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "btn btn-primary",
                                      staticStyle: {
                                        padding: "1px",
                                        margin: "1px"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.moveLeft(webPart)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-arrow-left"
                                      })
                                    ]
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "btn btn-primary",
                                      staticStyle: {
                                        padding: "1px",
                                        margin: "1px"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.moveRight(webPart)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-arrow-right"
                                      })
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _c("span", { staticClass: "scrollmenuDiv" }, [
                              _vm._v("|")
                            ])
                          ])
                        : _vm._e()
                    ])
                  }),
                  _vm._l(_vm.propsHeader.MenuLinks, function(item, index) {
                    return _c("span", { key: index }, [
                      _c(
                        "a",
                        {
                          staticClass: "scrollMenuLink",
                          attrs: { href: item.LinkUrl, target: item.LinkTarget }
                        },
                        [_vm._v(_vm._s(item.LinkText))]
                      ),
                      _c("span", { staticClass: "scrollmenuDiv" }, [
                        _vm._v("|")
                      ])
                    ])
                  }),
                  _vm._l(_vm.getAdvPages(), function(item, index) {
                    return _c("span", { key: index }, [
                      _c(
                        "a",
                        {
                          staticClass: "scrollMenuLink",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.gotoPage(item.SystemId)
                            }
                          }
                        },
                        [_vm._v(_vm._s(item.Name))]
                      ),
                      _c("span", { staticClass: "scrollmenuDiv" }, [
                        _vm._v("|")
                      ])
                    ])
                  })
                ],
                2
              )
            ])
          ]
        )
      ]),
      _vm.Header && _vm.Common
        ? _c("COM_Header_Setting", {
            ref: "headerSetting",
            attrs: { Header: _vm.Header, common: _vm.Common }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }